import api from 'service/api'
import axios from 'axios'
import * as service from 'service'

import { getBaseURL } from 'service/env'

const dponetAPI = api.create('dponet')
const baseURL = getBaseURL('dponet')

const get = async ({ incidentId = '', ...params }) => {
  return await dponetAPI.get(`/incidents/${incidentId}`, { params })
}

const exportReport = async (params) =>
  await dponetAPI.post('/incidents/export_report', params)

const create = async ({ ...data }) => {
  const formData = new FormData()

  formData.append('incident[discovery_description]', data.discoveryDescription)
  formData.append('incident[incident_type]', data.incidentType)

  if (
    !!data?.incident?.convertedComplaintIncident &&
    !!data?.incident?.complaintId
  ) {
    formData.append(
      'incident[converted_complaint_incident]',
      data?.incident?.convertedComplaintIncident,
    )
    formData.append('incident[complaint_id]', data?.incident?.complaintId)
  }

  data?.detectionAttachments &&
    Array.from(data?.detectionAttachments).map((detectionAttachment) => {
      return formData.append(
        `incident[detection_attachments][]`,
        detectionAttachment,
      )
    })

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Content-Disposition': 'attachment',
      Authorization: service.dponet.auth.getToken(),
    },
  }

  return await axios({
    method: 'POST',
    url: `${baseURL}/incidents`,
    data: formData,
    ...config,
  })
}

const detectionStep = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.putForm(
    `/incidents/${incidentId}/detection_step`,
    data,
  )
}

const investigationStep = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/investigation_step`,
    data,
  )
}

const avaliationStep = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.putForm(
    `/incidents/${incidentId}/avaliation_step`,
    data,
  )
}

const detalingStep = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(`/incidents/${incidentId}/detaling_step`, data)
}

const lessonsLearnedStep = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/lessons_learned_step`,
    data,
  )
}

const destroy = async ({ incidentId }) => {
  return await dponetAPI.delete(`/incidents/${incidentId}`)
}

const linkProcess = async ({ incidentId, dataProcessId }) => {
  return await dponetAPI.post(
    `/incidents/${incidentId}/link_data_process/${dataProcessId}`,
  )
}

const unlinkProcess = async ({ incidentId, dataProcessId }) => {
  return await dponetAPI.delete(
    `/incidents/${incidentId}/unlink_data_process/${dataProcessId}`,
  )
}

const logs = async ({ incidentId }) => {
  return await dponetAPI.get(`/incidents/${incidentId}/logs`)
}

const options = async ({ ...params }) => {
  return await dponetAPI.get('/incident_options', { params })
}

const addStepRisk = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(`/risk_consequence/${incidentId}`, data)
}

const addStepSecurity = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(
    `/technical_administrative_security/${incidentId}`,
    data,
  )
}

const createMinimal = async (data) => {
  return await dponetAPI.post(`/incidents/minimal`, data)
}

const concludeStep = async ({ incidentId = '', step = '' }) => {
  return await dponetAPI.put(`/incidents/${incidentId}/steps/${step}/conclude`)
}

const reopenLegalOpinion = async ({ incidentId = '', ...params }) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/steps/reopen_legal_opinion`,
    params,
  )
}

const createHighRiskLargeScale = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.post(
    `/incidents/${incidentId}/incident_high_risk_answers/large_scale`,
    data,
  )
}

const updateHighRiskLargeScale = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/incident_high_risk_answers/large_scale`,
    data,
  )
}

const createHighRiskAffectSignificantly = async ({
  incidentId = '',
  ...data
}) => {
  return await dponetAPI.post(
    `/incidents/${incidentId}/incident_high_risk_answers/affect_significantly`,
    data,
  )
}

const updateHighRiskAffectSignificantly = async ({
  incidentId = '',
  ...data
}) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/incident_high_risk_answers/affect_significantly`,
    data,
  )
}

const createHighRiskSpecificCriteria = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.post(
    `/incidents/${incidentId}/incident_high_risk_answers/specific_criteria`,
    data,
  )
}

const updateHighRiskSpecificCriteria = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/incident_high_risk_answers/specific_criteria`,
    data,
  )
}

const getHighRisk = async ({ incidentId = '' }) => {
  return await dponetAPI.get(`/incidents/${incidentId}/incident_high_risks`)
}

const updateHighRisk = async ({ incidentId = '', ...data }) => {
  return await dponetAPI.put(
    `/incidents/${incidentId}/incident_high_risks`,
    data,
  )
}

const highRiskToExcel = async ({ incidentId = '' }) => {
  return await dponetAPI.get(
    `/incidents/${incidentId}/incident_high_risks/high_risk_to_excel`,
  )
}

const incidents = {
  addStepRisk,
  addStepSecurity,
  avaliationStep,
  concludeStep,
  create,
  createHighRiskAffectSignificantly,
  createHighRiskLargeScale,
  createHighRiskSpecificCriteria,
  createMinimal,
  destroy,
  detalingStep,
  detectionStep,
  exportReport,
  get,
  getHighRisk,
  highRiskToExcel,
  investigationStep,
  lessonsLearnedStep,
  linkProcess,
  logs,
  options,
  reopenLegalOpinion,
  unlinkProcess,
  updateHighRisk,
  updateHighRiskAffectSignificantly,
  updateHighRiskLargeScale,
  updateHighRiskSpecificCriteria,
}
export default incidents
